import { TimeCategoriesSettingsRootPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import hasFeature from 'modules/core/lib/hasFeature'

import useFetchData from 'modules/billing/hooks/useFetchData'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import BreakConfigurations from 'modules/time_categories_settings/components/BreakConfigurations'
import NewWorkTimeCategories from 'modules/time_categories_settings/components/NewWorkTimeCategories'
import WorkTimeCategories from 'modules/time_categories_settings/components/WorkTimeCategories'
import { useGetBreakConfigurations } from 'modules/time_categories_settings/hooks/breakConfigurations/useGetBreakConfigurations'
import { useFetchTimeSettingsCustomTimeRangeCategories } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'
import CollectionsBootstrap from 'modules/time_categories_settings/lib/CollectionsBootstrap'

const Container = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, error } = useQuery(TimeCategoriesSettingsRootPageDocument, {})
  const { categories, loading: loadingCategories } =
    useFetchTimeSettingsCustomTimeRangeCategories(companyId)
  const { breakConfigurations, loading: loadingBreaks } = useGetBreakConfigurations({
    active: true,
  })
  const { loading: loadingTimeTracking, isNotFound: timeTrackingNotInPlan } =
    useFetchData('time_tracking')

  useEffect(() => {
    track(trackingEvents.timeTracking.timeCategoriesSettingsPageVisited)
  }, [])

  const isLoading = loadingCategories || loadingBreaks || loadingTimeTracking

  const canManageBreakSetting = data?.timeSettings._policies.manageBreakConfigurations.can
  const canManageTimeCategories = data?.timeSettings._policies.manageTimeRangeCategories.can
  const hasMajoration = hasFeature('dev_time_tracking_majoration')

  const TimeCategories = hasMajoration ? NewWorkTimeCategories : WorkTimeCategories

  return (
    <ResponsivePage.Body
      authorized={!timeTrackingNotInPlan}
      showHeader={false}
      variant="full"
      loading={isLoading}
      error={error}
    >
      {canManageTimeCategories && <TimeCategories companyId={companyId} categories={categories} />}
      {canManageBreakSetting && <BreakConfigurations breakConfigurations={breakConfigurations} />}
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
